// Report.js
import React from "react"
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
} from "@react-pdf/renderer"
import { getDateFn } from "./ReportUtility.js"


const border_color = "#2f2e2e"
const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#FFFFFF',

  },
  section: {
    fontFamily: 'Helvetica',
    margin: 20,
    padding: 0,
    flexGrow: 1,
    fontSize: "9px",
    borderColor: "#475569"
  },

  table: {
    display: 'table',
    width: '100%',
    borderStyle: 'solid',
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 0
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row',
    width: "100%"

  },
  tableColHeader: {
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    lineHeight: "1.5"
  },
  tableCol: {
    borderStyle: 'solid',
    borderTopWidth: 0,
    borderColor: border_color,
    padding: "2",
  },
  tableCell: {
    padding: 4,
  },
  colWidth_lg: {
    width: '70%',
    borderRightWidth: 1
  },
  colWidth_sm: {
    width: '30%'
  },

  colMid: {
    padding: "0px 3px 0px 3px"
  },

  fontBold: {
    fontSize: "9px", fontFamily: 'Helvetica-Bold',
  },
  tableTopBorder: {
    borderTop: 1,
    borderColor: border_color,
  },
  tableHeading: {
    fontSize: "13px",
    textTransform: "uppercase",
    textAlign: "center",
    fontFamily: 'Helvetica-Bold'
  },
  colWidth: {
    width: "80%",
    textAlign: "left",
  },
  colWidth_label: {
    textAlign: "right",
    width: "20%",
    fontFamily: 'Helvetica-Bold',
    fontSize: "9px"
  },
  footerText: {
    fontSize: "8px",
    fontWeight: 600,
    textTransform: "uppercase",
    fontFamily: 'Helvetica-Bold'
  },
  tblBorderLeft: {
    borderLeftWidth: 1
  },
  tblBorderRight: {
    borderRightWidth: 1
  }

})

// Create PDF component
const RptVoucher = ({ data }) => {
  
  return (
    <Document pageMode="fullScreen">
      <Page size="A4" style={styles.page}>
        {data && data.map((item, index) => {
          return (
            <>
              <View style={styles.section}>
                {/* HEader */}
                <View style={[styles.table]}>
                  <View style={[styles.tableRow, styles.tableTopBorder, styles.tblBorderLeft, styles.tblBorderRight]}>
                    <View style={[styles.tableCol, { minHeight: '60px', textAlign: "center", width: "100%" }]}>
                      <Text style={[styles.tableCell, styles.tableHeading]}>{item?.compname}</Text>
                      <Text>{item?.comp_add1 +
                        " " +
                        item?.comp_add2 +
                        " " +
                        item?.comp_add3 +
                        " " +
                        item?.comp_add4 +
                        " " +
                        item?.Comp_City +
                        " " +
                        item?.comp_State
                      }</Text>

                      <Text>{item?.comp_contectno1 ? ' (M) ' + item?.comp_contectno1 : "" +
                        "   " +
                        item?.comp_contectno2 ? ' (O) ' + item?.comp_contectno2 : ""
                      }</Text>
                    </View>

                  </View>
                </View>
                <View style={[styles.table]}>
                  <View style={[styles.tableRow, styles.tableTopBorder, styles.tblBorderLeft]}>
                    <View style={[styles.tableCol, styles.colWidth_lg]}>
                      <View style={[styles.table, { width: "100%" }]}>
                        <View style={[styles.tableRow]}>

                          <View style={[styles.tableCol, styles.colWidth_label]}>
                            <Text style={styles.tableCell}>Party</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colMid]}>
                            <Text style={styles.tableCell}>:</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colWidth]}>
                            <Text style={styles.tableCell}>{item.PartyName}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow]}>

                          <View style={[styles.tableCol, styles.colWidth_label]}>
                            <Text style={styles.tableCell}>Address</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colMid]}>
                            <Text style={styles.tableCell}>:</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colWidth, { }]}>
                            <Text style={styles.tableCell}>{item?.PAdd_1 + ' ' +
                              item?.PAdd_2  + ' ' +
                              item?.PAdd_3 + ' ' +
                              item?.PAdd_4  + ' '
                            } </Text>
                          </View>

                        </View>
                        <View style={[styles.tableRow]}>

                          <View style={[styles.tableCol, styles.colWidth_label]}>
                            <Text style={styles.tableCell}>Contact No</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colMid]}>
                            <Text style={styles.tableCell}>:</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colWidth]}>
                            <Text style={styles.tableCell}>{item.PCont_1 ? item?.PCont_1 : ""}</Text>
                          </View>

                        </View>
                        {item?.Vou_Type == "R" ?
                          <View style={[styles.tableRow]}>

                            <View style={[styles.tableCol, styles.colWidth_label]}>
                              <Text style={styles.tableCell}>Bank Name</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colMid]}>
                              <Text style={styles.tableCell}>:</Text>
                            </View>
                            <View style={[styles.tableCol, styles.colWidth]}>
                              <Text style={styles.tableCell}>{item.BankName}</Text>
                            </View>

                          </View> : ""}
                        <View style={[styles.tableRow]}>

                          <View style={[styles.tableCol, styles.colWidth_label]}>
                            <Text style={styles.tableCell}>
                              {item?.Vou_Type == "R" ? 'Debited A/C.' : 'Credited A/C.'}</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colMid]}>
                            <Text style={styles.tableCell}>:</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colWidth]}>
                            <Text style={styles.tableCell}>{item.BookName}</Text>
                          </View>

                        </View>
                      </View>
                    </View>
                    <View style={[styles.tableCol, styles.colWidth_sm, { borderRightWidth: 1 }]}>
                      <View style={[styles.table]}>
                        <View style={[styles.tableRow]}>
                          <View style={[styles.tableCol, { width: '100%', fontFamily: 'Helvetica-Bold', textAlign: "center", borderBottomWidth: 1 }]}>
                            <Text style={styles.tableCell}> {item?.Vou_Type == "R" ? "RECEIPT VOUCHER" : "PAYMENT VOUCHER"}</Text>
                          </View>
                        </View>
                        <View style={[styles.tableRow]}>
                          <View style={[styles.tableCol, styles.fontBold, { width: "40%", textAlign: "right" }]}>
                            <Text style={styles.tableCell}>Date</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colMid]}>
                            <Text style={styles.tableCell}>:</Text>
                          </View>
                          <View style={[styles.tableCol, { textAlign: "right" }]}>
                            <Text style={styles.tableCell}>{getDateFn(item.Chq_Date)}</Text>
                          </View>
                        </View>

                        <View style={[styles.tableRow]}>
                          <View style={[styles.tableCol, styles.fontBold, { width: "40%", textAlign: "right" }]}>
                            <Text style={styles.tableCell}>Cheque No.</Text>
                          </View>
                          <View style={[styles.tableCol, styles.colMid,]}>
                            <Text style={styles.tableCell}>:</Text>
                          </View>
                          <View style={[styles.tableCol, { textAlign: "right" }]}>
                            <Text style={styles.tableCell}>{item.Chq_No}</Text>
                          </View>
                        </View>
                      </View>
                    </View>
                  </View>
                </View>
                <View style={[styles.table]}>
                  <View style={[styles.tableRow, styles.tableTopBorder, styles.tblBorderLeft, styles.tblBorderRight, { borderBottomWidth: 1 }]}>
                    <View style={[styles.tableCol, styles.colWidth_lg, styles.fontBold]}>
                      <Text style={[styles.tableCell]}>Particuler</Text>
                    </View>
                    <View style={[styles.tableCol, styles.colWidth_sm, styles.fontBold, { textAlign: "center" }]}>
                      <Text style={[styles.tableCell]}> {item?.Vou_Type == "R" ? "Received Amount (Rs)" : "Paid Amount (Rs)"}</Text>
                    </View>
                  </View>
                  <View style={[styles.tableRow, styles.tblBorderLeft, styles.tblBorderRight, { borderBottomWidth: 1, minHeight: '50px' }]}>
                    <View style={[styles.tableCol, styles.colWidth_lg, { overflow: "hidden", lineHeight: "1.5" }]}>
                      <Text style={[styles.tableCell,
                      ]}>{item?.Remark && item?.Remark?.split(",").length > 0 ?
                        item?.Remark && item.Remark.split(",").length > 0 &&
                        item.Remark.split(",").map((ele) => {
                          return (<Text style={styles.tableCol}>
                            {ele + ' , '}
                          </Text>)
                        })
                        : item.Remark
                        }
                      </Text>
                    </View>
                    <View style={[styles.tableCol, styles.fontBold, styles.colWidth_sm, { textAlign: "center", fontSize: "12px" }]}>
                      <Text style={[styles.tableCell]}> {item.Chq_Amt + ".00"}</Text>
                    </View>
                  </View>
                  <View style={[styles.tableRow]}>
                    <View style={[styles.tableCol, styles.footerText, styles.colWidth_lg, { borderRightWidth: 0 }]}>
                      <Text style={[styles.tableCell]}>Prepared By</Text>
                    </View>
                    <View style={[styles.tableCol, styles.footerText, styles.colWidth_sm, { textAlign: "right" }]}>
                      <Text style={[styles.tableCell]}>{item.compname}</Text>
                    </View>
                  </View>
                </View>
              </View>
            </>
          )
        })}
      </Page>
    </Document>
  )
}
export default RptVoucher
